export default function listBncc() {
  const query = `{listBncc {id, name, description}}`;
  return query;
}
